<template>
	<div class="website-display">
		<iframe
				v-if="url"
				:src="url"
				width="100%"
				frameborder="0"
				allowfullscreen
				:key="refreshKey"
				style="height:90vh"
				></iframe>
		<p v-else>Please provide a valid URL to display.</p>
	</div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
	name: 'WebsiteDisplay',
	props: {
		refresh: {
			type: Number,
			required: true,
		},
		url: {
			type: String,
			required: true,
			validator: (value: string) => {
				// A basic check to see if the prop is a valid URL
				return value.startsWith('http://') || value.startsWith('https://');
			},
		},
	},
	setup(props) {
		const refreshKey = computed(() => props.refresh);

		return {
			refreshKey,
		};
	},
});
</script>

<style scoped>
/* Add any styles you need here */
</style>

